import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Status, Store, STORE_URL } from '@insite-store360/shared';
import { catchError, Observable } from 'rxjs';
import { StoreApiResponse } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  // private readonly STORE_API_URL = `${environment.apiUrl}/store`;
  private readonly STORE_API_URL = `${STORE_URL}/store`;
  private readonly STORE_PUBLIC_API_URL = `${STORE_URL}/storePublic`;
  // private readonly STORE_API_URL = `http://localhost:3001/api`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  /** Store page Supplier Mapping bulk template (Vietnam only). */
  public downloadSupplierMappingTemplate(countryId: number): Observable<Blob> {
    return this.http
      .get(`${this.STORE_API_URL}/downloadSupplierMappingTemplate`, {
        params: new HttpParams().set('countryId', String(countryId)),
        responseType: 'blob',
      })
      .pipe(catchError(this.errorHandler.handleError));
  }

  /** Uploads a filled Supplier Mapping template; returns per-row results. */
  public importSupplierMapping(file: File, countryId: number): Observable<any> {
    const form = new FormData();
    form.append('file', file);
    form.append('countryId', String(countryId));
    return this.http
      .post<any>(`${this.STORE_API_URL}/importSupplierMapping`, form)
      .pipe(catchError(this.errorHandler.handleError));
  }
  // /**
  //  * Sends a POST request to the server to add a new store's information.
  //  * @param storeDetails - The store data to be added
  //  * @returns
  //  */
  // public addStoreInfo(storeDetails: Store): Observable<Store> {
  //   console.log(storeDetails);

  //   return this.http
  //     .post<Store>(`${this.STORE_API}/addStore`, storeDetails)
  //     .pipe(catchError(this.errorHandler.handleError));
  // }

  // /**
  //  * Updates store information on the server.
  //  * @param id - The unique identifier of the store to be updated.
  //  * @param data - The store data to be updated.
  //  * @returns An Observable that emits the updated store object.
  //  */
  // public updateStoreInfo(id: number, data: Store): Observable<Store> {
  //   return this.http
  //     .put<Store>(`${this.STORE_API_URL}/update/${id}`, data)
  //     .pipe(catchError(this.errorHandler.handleError));
  // }

  /**
   * Updates country information on the server.
   * @param id - The unique identifier of the master country to be updated.
   * @param data - The master country data to be updated.
   * @returns An Observable that emits the updated Master object.
   */
  public updateStore(storeData: Store): Observable<any> {
    return this.http
      .put<any>(`${this.STORE_API_URL}/update`, storeData)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getStoreInfo(params: {
    pageIndex: number;
    pageSize: number;
    searchFilter?: string;
  }): Observable<StoreApiResponse> {
    let queryParams = new HttpParams()
      .set('pageIndex', params.pageIndex)
      .set('pageSize', params.pageSize);
    if (params.searchFilter) {
      queryParams = queryParams.set('searchFilter', params.searchFilter);
    }
    return this.http
      .get<StoreApiResponse>(`${this.STORE_API_URL}/getStore`, {
        params: queryParams,
      })
      .pipe(catchError(this.errorHandler.handleError));
  }

  // /**
  //  * Deletes a store from the server.
  //  * @param id - The unique identifier of the store to be deleted.
  //  * @returns An Observable that emits a confirmation message upon successful deletion.
  //  */
  // public deleteStore(id: number): Observable<string> {
  //   return this.http
  //     .delete<string>(`${this.STORE_API_URL}/deleteStore/${id}`)
  //     .pipe(catchError(this.errorHandler.handleError));
  // }

  /**
   * Imports a list of stores into the server.
   * @param data - An array of Store objects to be imported.
   * @returns An Observable that emits an array of imported Store objects upon successful import.
   */
  public importStores(data: Store[]): Observable<Store[]> {
    return this.http
      .post<Store[]>(`${this.STORE_API_URL}/importStores`, data)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // **
  //  * Imports a list of stores into the server
  // public importStoresData(data: any): Observable<Store[]> {
  //   console.log(data);

  //   return this.http
  //     .post<Store[]>(`${this.STORE_API_URL}/importStoretData`, data)
  //     .pipe(catchError(this.errorHandler.handleError));
  // }

  /**
   * Fetches store data from the server and returns it as a Blob.
   * The response type is set to 'blob' to handle binary data, such as files.
   *
   * @returns An Observable emitting a Blob containing the store data.
   */
  // public exportStores(params?: {
  //   searchFilter?: string,
  //   countryId?: number[],
  //   stateId?: number[],
  //   cityId?: number[],
  //   channelId?: number[],
  //   accountId?: number[],
  // }): Observable<Blob> {

  //   let queryParams = new HttpParams()
  //   if (params?.searchFilter) {
  //     queryParams = queryParams.set('searchFilter', params.searchFilter);
  //   }

  //   if (params?.countryId && params.countryId.length > 0) {
  //     queryParams = queryParams.set('countryId', params.countryId.join(','));
  //   }

  //   if (params?.stateId && params.stateId.length > 0) {
  //     queryParams = queryParams.set('stateId', params.stateId.join(','));
  //   }

  //   if (params?.cityId && params.cityId.length > 0) {
  //     queryParams = queryParams.set('cityId', params.cityId.join(','));
  //   }

  //   if (params?.accountId && params.accountId.length > 0) {
  //     queryParams = queryParams.set('accountId', params.accountId.join(','));
  //   }

  //   if (params?.channelId && params.channelId.length > 0) {
  //     queryParams = queryParams.set('channelId', params.channelId.join(','));
  //   }

  //   const columns: string[] = [
  //     'Store ID',
  //     'Store Name',
  //     'Store Code',
  //     'Store Address',
  //     'Telephone Number',
  //     'Email',
  //     'Account',
  //     'Region',
  //     'Country',
  //     'AreaGroup',
  //     'State',
  //     'City',
  //     'Contact Person',
  //     'Location Longitude',
  //     'Location Latitude',
  //     'Focus Store',
  //     'Store Brand',
  //     'Online/Offline',
  //     'With Promoter',
  //   ]; //export needed columns
  //   return this.http
  //     .post<Blob>(
  //       `${this.STORE_API_URL}/downloadExcelReport`,
  //       { columns },
  //       {
  //         params: queryParams,
  //         responseType: 'blob' as 'json',
  //       }
  //     )
  //     .pipe(catchError(this.errorHandler.handleError));
  // }

  /**
   * Updates the active status of the store.
   *
   * @param storeStatus - The object containing the store's ID and the new store status to be updated.
   * @returns An Observable of the updated Store object.
   */

  public updateStoreStatus(storeStatus: Status): Observable<Store> {
    return this.http
      .put<Store>(
        `${this.STORE_API_URL}/updateStoreStatus/${storeStatus.id}`,
        storeStatus
      )
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Sends a POST request to the server to add a new store's information.
   * @param storeDetails - The store data to be added
   * @returns
   */

  public getStoreDetails(
    params: {
      pageIndex: any,
      pageSize: any,
      searchFilter?: string,
      countryIds?: number[],
      regionIds?: number[],
      userRoleId?: number[],
      status?: number
    }
  ): Observable<any> {

    let queryParams = new HttpParams()
      .set('pageIndex', params.pageIndex)
      .set('pageSize', params.pageSize);
    if (params.searchFilter) {
      queryParams = queryParams.set('searchFilter', params.searchFilter);
    }

    if (params.countryIds) {
      queryParams = queryParams.set('countryIds', params.countryIds.join(','));
    }

    if (params.regionIds && params.regionIds.length > 0) {
      queryParams = queryParams.set('regionIds', params.regionIds.join(','));
    }

    if (params.userRoleId && params.userRoleId.length > 0) {
      queryParams = queryParams.set('userRoleId', params.userRoleId.join(','));
    }

    if (params.status !== undefined) {
      queryParams = queryParams.set('status', params.status);
    }

    return this.http
      .get<any>(
        `${this.STORE_API_URL}/getAll`, { params: queryParams }
      )
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Gets store details using the v2 API endpoint with camelCase response
   * @param params - Query parameters for pagination and filtering
   * @returns Observable with camelCase store data
   */
  public getStoreDetailsV2(
    params: {
      pageIndex: any,
      pageSize: any,
      searchFilter?: string,
      countryIds?: number[],
      regionIds?: number[],
      userRoleId?: number[],
      status?: number
    }
  ): Observable<any> {

    let queryParams = new HttpParams()
      .set('pageIndex', params.pageIndex)
      .set('pageSize', params.pageSize);
    if (params.searchFilter) {
      queryParams = queryParams.set('searchFilter', params.searchFilter);
    }

    if (params.countryIds) {
      queryParams = queryParams.set('countryIds', params.countryIds.join(','));
    }

    if (params.regionIds && params.regionIds.length > 0) {
      queryParams = queryParams.set('regionIds', params.regionIds.join(','));
    }

    if (params.userRoleId && params.userRoleId.length > 0) {
      queryParams = queryParams.set('userRoleId', params.userRoleId.join(','));
    }

    if (params.status !== undefined) {
      queryParams = queryParams.set('status', params.status);
    }

    return this.http
      .get<any>(
        `${this.STORE_API_URL}/v2/getAll`, { params: queryParams }
      )
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
* Sends a POST request to the server to add a new store's information.
* @param dashboardstore - The store data to be added
* @returns
*/

  public getDashboardStoreDetails(
    params: {
      pageIndex: any,
      pageSize: any,
      searchFilter?: string,
      countryId?: number[],
      stateId?: number[],
      cityId?: number[],
      channelId?: number[],
      accountId?: number[],
      storeId?: number[],
      withPromoter?: string,
      focusStore?: string,
      status?: number
    }
  ): Observable<any> {

    let queryParams = new HttpParams()
      .set('pageIndex', params.pageIndex)
      .set('pageSize', params.pageSize);
    if (params.searchFilter) {
      queryParams = queryParams.set('searchFilter', params.searchFilter);
    }

    if (params.countryId && params.countryId.length > 0) {
      queryParams = queryParams.set('countryId', params.countryId.length > 1 ? params.countryId.join(',') : params.countryId[0].toString());
    }

    if (params.stateId && params.stateId.length > 0) {
      queryParams = queryParams.set('stateId', params.stateId.join(','));
    }

    if (params.cityId && params.cityId.length > 0) {
      queryParams = queryParams.set('cityId', params.cityId.join(','));
    }

    if (params.channelId && params.channelId.length > 0) {
      queryParams = queryParams.set('channelId', params.channelId.join(','));
    }

    if (params.accountId && params.accountId.length > 0) {
      queryParams = queryParams.set('accountId', params.accountId.join(','));
    }

    if (params.storeId && params.storeId.length > 0) {
      queryParams = queryParams.set('storeId', params.storeId.join(','));
    }

    if (params.withPromoter && params.withPromoter !== 'ALL') {
      queryParams = queryParams.set('withPromoter', params.withPromoter);
    }

    if (params.focusStore && params.focusStore !== 'ALL') {
      queryParams = queryParams.set('focusStore', params.focusStore);
    }

    if (params.status !== undefined) {
      queryParams = queryParams.set('status', params.status);
    }

    return this.http
      .get<any>(
        `${this.STORE_API_URL}/getAllDashboardStore`, { params: queryParams }
      )
      .pipe(catchError(this.errorHandler.handleError));
  }



  /**
   * Sends a POST request to the server to add a new store's information.
   * @param storeDetails - The store data to be added
   * @returns
   */
  public addStoreDetails(storeDetails: Store): Observable<Store> {
    return this.http
      .post<Store>(`${this.STORE_API_URL}/save`, storeDetails)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getContactDetails(storeId: number): Observable<any> {
    return this.http
      .get<any>(`${this.STORE_API_URL}/getContactDetails/${storeId}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Deletes a store from the server.
   * @param id - The unique identifier of the store to be deleted.
   * @returns An Observable that emits a confirmation message upon successful deletion.
   */
  public deleteStore(id: number): Observable<string> {
    return this.http
      .delete<string>(`${this.STORE_API_URL}/delete/${id}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Toggel status.
   * @param id - The unique identifier of the status
   */

  updateToggleStatus(id: number): Observable<any> {
    return this.http
      .put<any>(`${this.STORE_API_URL}/changeStatus/${id}`, null)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // Channel and Account API:

  public getChannelDetails(): Observable<any> {
    return this.http
      .get<any>(`${this.STORE_API_URL}/channel/getAll`) // Include the data payload here
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAccountDetails(): Observable<any> {
    return this.http
      .get<any>(`${this.STORE_API_URL}/account/getAll`) // Include the data payload here
      .pipe(catchError(this.errorHandler.handleError));
  }

  // to get the dropdown for regions and country in text in excel

  // public downloadExcelTemplate(countryId?: number[]) {
  //   let params: any = { responseType: 'blob' as 'json' };
  //   if (countryId) {
  //     params.params = { countryId };
  //   }
  //   return this.http
  //     .get(`${this.STORE_API_URL}/downloadExcelTemplate`, params)
  //     .pipe(catchError(this.errorHandler.handleError));
  // }

  //To get the store name based on the country selection
  public getStoreName(id: number[]) {
    return this.http
      .get(`${this.STORE_API_URL}/getAllStoreByCountryIds/?ids=${id}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // to get active store status
  public getAllActiveStore(searchFilter?: string): Observable<any> {
    let queryParams = new HttpParams();
    if (searchFilter) {
      queryParams = queryParams.set('searchFilter', searchFilter);
    }
    return this.http
      .get<any>(`${this.STORE_API_URL}/getAllActive`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAllActiveChannel(): Observable<any> {
    return this.http
      .get<any>(`${STORE_URL}/channel/getAllActive`)
      .pipe(catchError(this.errorHandler.handleError));
  }


  public getAllAccountByCountryId(params: { countryId: any, channelId?: any, searchFilter?: string }): Observable<any> {
    let queryParams = new HttpParams();
    const cIds = Array.isArray(params?.countryId)
      ? params.countryId
      : (params?.countryId != null && params?.countryId !== '' ? [params.countryId] : []);
    if (cIds.length > 0) {
      queryParams = queryParams.set('countryId', cIds.join(','));
    }
    const chIds = Array.isArray(params?.channelId)
      ? params.channelId
      : (params?.channelId != null && params?.channelId !== '' ? [params.channelId] : []);
    if (chIds.length > 0) {
      queryParams = queryParams.set('channelId', chIds.join(','));
    }
    if (params?.searchFilter) {
      queryParams = queryParams.set('searchFilter', params.searchFilter);
    }
    return this.http
      .get<any>(`${STORE_URL}/account/getAccountByCountryIdChannelId`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  /** Store 360 Account tab — regionId is required; countryId and stateId are optional. */
  public getAccountsByRegion(params: {
    regionId: number[];
    countryId?: number[];
    stateId?: number[];
    searchFilter?: string;
  }): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.set('regionId', params.regionId.join(','));
    if (params.countryId?.length) {
      queryParams = queryParams.set('countryId', params.countryId.join(','));
    }
    if (params.stateId?.length) {
      queryParams = queryParams.set('stateId', params.stateId.join(','));
    }
    if (params.searchFilter) {
      queryParams = queryParams.set('searchFilter', params.searchFilter);
    }
    return this.http
      .get<any>(`${STORE_URL}/account/getAccountsByRegion`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }


  /**
   * Totals for stores, accounts, and promoters.
   * Pass countryId and/or regionId to scope; omit both for all.
   */
  public getStoreAccountPromoterCounts(params?: {
    countryId?: number | number[];
    regionId?: number | number[];
  }): Observable<any> {
    let queryParams = new HttpParams();
    if (params?.countryId != null && params.countryId !== undefined) {
      const countryIds = Array.isArray(params.countryId)
        ? params.countryId
        : [params.countryId];
      if (countryIds.length) {
        queryParams = queryParams.set('countryId', countryIds.join(','));
      }
    }
    if (params?.regionId != null && params.regionId !== undefined) {
      const regionIds = Array.isArray(params.regionId)
        ? params.regionId
        : [params.regionId];
      if (regionIds.length) {
        queryParams = queryParams.set('regionId', regionIds.join(','));
      }
    }
    return this.http
      .get<any>(`${STORE_URL}/dashboard/getStoreAccountPromoterCounts`, {
        params: queryParams,
      })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAllCoverage(params: { countryId: number }): Observable<any> {
    let queryParams = new HttpParams()
      .set('countryId', params.countryId)
    return this.http
      .get<any>(`${STORE_URL}/dashboard/getAllCoverage`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAllFieldTeams(params: { countryId: number }): Observable<any> {
    let queryParams = new HttpParams()
      .set('countryId', params.countryId)
    return this.http
      .get<any>(`${STORE_URL}/dashboard/getAllFieldTeamsCounts`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }


  public getAllCurrentMonthsStoreVisitsCounts(params: { countryId: string }): Observable<any> {
    let queryParams = new HttpParams()
      .set('countryId', params.countryId)
    return this.http
      .get<any>(`${STORE_URL}/dashboard/getAllCurrentMonthsStoreVisitsCounts`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }


  public getAllPastSevenDaysStoreVisitsCounts(params: { countryId: number }): Observable<any> {
    let queryParams = new HttpParams()
      .set('countryId', params.countryId)
    return this.http
      .get<any>(`${STORE_URL}/dashboard/getAllPastSevenDaysStoreVisitsCounts`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }



  public getAllPastFourteenDaysSales(params: { categoryId: number, subCategoryId: number, valueType: string, countryId: string, storeId?: number }): Observable<any> {
    let queryParams = new HttpParams()
      .set('categoryId', params.categoryId)
      .set('subCategoryId', params.subCategoryId)
      .set('valueType', params.valueType)
      .set('countryId', params.countryId)
    if (params.storeId) {
      queryParams = queryParams.set('storeId', params.storeId);
    }

    return this.http
      .get<any>(`${STORE_URL}/dashboard/getAllPastFourteenDaysSales`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAllSurveySalesData(params: { surveyId: number, countryId: string, storeId?: number, pageSize?: number, pageIndex?: number }): Observable<any> {
    let queryParams = new HttpParams()
      .set('surveyId', params.surveyId)
      .set('countryId', params.countryId)
    if (params.storeId) {
      queryParams = queryParams.set('storeId', params.storeId);
    }
    if (params.pageIndex) {
      queryParams = queryParams.set('pageIndex', params.pageIndex);
    }
    if (params.pageSize) {
      queryParams = queryParams.set('pageSize', params.pageSize);
    }

    return this.http
      .get<any>(`${STORE_URL}/dashboard/getAllSurveySalesData`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  // to get stores by country IDs for sellout component
  public getAllStoresByCountryIds(countryIds: number[]): Observable<any> {
    const ids = Array.isArray(countryIds)
      ? countryIds
      : (countryIds != null && countryIds !== '' ? [countryIds] : []);
    const idsParam = ids.join(',');
    return this.http
      .get<any>(`${this.STORE_API_URL}/getAllStoreByCountryIds?ids=${idsParam}`)
      .pipe(catchError(this.errorHandler.handleError));
  }
  public getStoreByCountryAndAccount(countryIds: number | number[], accountIds: number | number[], searchFilter?: string): Observable<any> {

    let queryParams = new HttpParams()

    // Handle countryIds
    if (countryIds && (Array.isArray(countryIds) && countryIds.length > 0)) {
      queryParams = queryParams.set('countryId', countryIds.join(','));
    }


    if (accountIds && (Array.isArray(accountIds) && accountIds.length > 0)) {
      queryParams = queryParams.set('accountId', accountIds.join(','));
    }
    if (searchFilter) {
      queryParams = queryParams.set('searchFilter', searchFilter);
    }
    return this.http
      .get<any>(`${this.STORE_API_URL}/getStoreByCountryAndAccount`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getStoreByCountryAndAccountPublic(countryIds: number | number[], accountIds: number | number[], searchFilter?: string): Observable<any> {

    let queryParams = new HttpParams()

    // Handle countryIds
    if (countryIds && (Array.isArray(countryIds) && countryIds.length > 0)) {
      queryParams = queryParams.set('countryId', countryIds.join(','));
    }


    if (accountIds && (Array.isArray(accountIds) && accountIds.length > 0)) {
      queryParams = queryParams.set('accountId', accountIds.join(','));
    }
    if (searchFilter) {
      queryParams = queryParams.set('searchFilter', searchFilter);
    }
    return this.http
      .get<any>(`${this.STORE_PUBLIC_API_URL}/getStoreByCountryAndAccount`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getStoreDetailsById(params: {
    storeId: number;
  }): Observable<StoreApiResponse> {

    return this.http
      .get<StoreApiResponse>(`${this.STORE_API_URL}/getStoreDetailById/${params.storeId}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public fetchMarketActivitiesImagesAndCounts(params: {
    currentPage: number;
    pageSize: number;
    querySelector: 'counts' | 'images';
    queryType?: string;
    country?: string[];
    brand?: string[];
    store_type?: string[];
    key_account?: string[];
    store?: string[];
    year?: number;
    month?: number;
  }): Observable<any> {
    let queryParams = new HttpParams()
      .set('currentPage', params.currentPage)
      .set('pageSize', params.pageSize)
      .set('querySelector', params.querySelector)
      .set('query_type', params.queryType || 'counts');

    if (params.country && params.country.length > 0) {
      queryParams = queryParams.set('country', params.country.join(','));
    }
    if (params.brand && params.brand.length > 0) {
      queryParams = queryParams.set('brand', params.brand.join(','));
    }
    if (params.store_type && params.store_type.length > 0) {
      queryParams = queryParams.set('store_type', params.store_type.join(','));
    }
    if (params.key_account && params.key_account.length > 0) {
      queryParams = queryParams.set('key_account', params.key_account.join(','));
    }
    if (params.store && params.store.length > 0) {
      queryParams = queryParams.set('store', params.store.join(','));
    }
    if (params.year) {
      queryParams = queryParams.set('year', params.year);
    }
    if (params.month) {
      queryParams = queryParams.set('month', params.month);
    }

    return this.http
      .get<any>(`${this.STORE_API_URL}/fetchMarketActivitesImagesAndCounts`, {
        params: queryParams,
      })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public resetStoreLocation(params: { storeId: number }): Observable<any> {
    return this.http
      .post<any>(`${this.STORE_API_URL}/resetStoreLocation`, params)
      .pipe(catchError(this.errorHandler.handleError));
  }

  //To check the unique store id for import store
  // public checkValidStoreIdAndName(existingStoreId: number[], existingName: string[]): Observable<any> {
  //   let data = { existingStoreId, existingName }
  //   return this.http
  //     .post<any>(`${this.STORE_API_URL}/checkValidStoreIdAndName`, data)
  //     .pipe(catchError(this.errorHandler.handleError));
  // }

  //To check the dropdown validation for store import
  // public storeDropDownCheck(data: any): Observable<any> {
  //   return this.http
  //     .post<any>(`${this.STORE_API_URL}/storeDropDownCheck`, data)
  //     .pipe(catchError(this.errorHandler.handleError));
  // }
  public getAllStoreSize(): Observable<any> {
    return this.http
      .get<any>(`${this.STORE_API_URL}/getAllStoreSize`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getDealerOptions(): Observable<
    Array<{ id: number; fullName: string; code: string; phoneNumber: string; email: string }>
  > {
    return this.http
      .get<any>(`${this.STORE_API_URL}/dealerOptions`)
      .pipe(catchError(this.errorHandler.handleError));
  }

}
